import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { createRef } from 'react';
import { searchLink } from '../../documents/data';
var SearchForm = /*#__PURE__*/function (_React$Component) {
  function SearchForm(props) {
    var _props$toShowSecurity;
    var _this;
    _classCallCheck(this, SearchForm);
    var toShowCopyOnFocus = props.toShowCopyOnFocus; // Destructure the toShowCopyOnFocus prop
    _this = _callSuper(this, SearchForm, [props]);
    _defineProperty(_this, "inp", void 0);
    _defineProperty(_this, "toShowSecurityMessage", true);
    _this.inp = createRef();
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.state = {
      toShowCopy: !toShowCopyOnFocus
    };
    _this.toShowSecurityMessage = (_props$toShowSecurity = props.toShowSecurityMessage) !== null && _props$toShowSecurity !== void 0 ? _props$toShowSecurity : true;
    return _this;
  }
  _inherits(SearchForm, _React$Component);
  return _createClass(SearchForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.ifFocusableOnLoad && this.inp.current) {
        this.inp.current.focus();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (this.props.toShowCopyOnFocus) {
        this.setState(function () {
          return {
            toShowCopy: true
          };
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      if (this.props.toShowCopyOnFocus) {
        this.setState(function () {
          return {
            toShowCopy: false
          };
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this$inp$current, _this$props;
      event.preventDefault();
      var query = ((_this$inp$current = this.inp.current) === null || _this$inp$current === void 0 ? void 0 : _this$inp$current.value) || '';
      var url = "".concat(searchLink, "#q=").concat(encodeURIComponent(query)).concat((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.homepage ? '&tmpl=home' : '');
      window.location.href = url;
    }
  }, {
    key: "render",
    value: function render() {
      var cl = this.props.className || '';
      return React.createElement(React.Fragment, null, React.createElement("form", {
        className: "bg-white border ".concat(cl),
        name: "global-form",
        method: "get",
        autoComplete: "off",
        spellCheck: "false",
        onSubmit: this.handleSubmit
      }, React.createElement("div", {
        className: "input-group",
        id: this.props.id
      }, React.createElement("label", {
        htmlFor: "".concat(this.props.id, "-input"),
        className: "visually-hidden"
      }, this.props.placeholder || 'Search'), React.createElement("input", {
        id: "".concat(this.props.id, "-input"),
        ref: this.inp,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        type: "text",
        className: "form-control border-end-0 border border-white",
        placeholder: this.props.placeholder || 'Search',
        name: "q"
      }), React.createElement("button", {
        className: "btn ecs-font-icon-act-search border-0 text-secondary h5 mb-0 ",
        type: "submit",
        "aria-label": this.props.placeholder || 'Search'
      }))), this.state.toShowCopy && this.toShowSecurityMessage && React.createElement("p", {
        className: "p-2 body-text-xs mb-0"
      }, "Don\u2019t enter personal info like your SSN, email or phone number"));
    }
  }]);
}(React.Component);
export default SearchForm;